import React, { useState, useEffect, useRef } from "react";
import { Box, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { BarChart } from "@mui/x-charts/BarChart";
import { useNavigate } from "react-router-dom";

const TopDepartmentRequest = ({ responseFemdepart = [], responseBemdepart = [] }) => {
    const navigate = useNavigate();

    const [selectedTab, setSelectedTab] = useState(0);
    const [topDepartments, setTopDepartments] = useState([]);
    const chartRef = useRef(null);

    const handleTabChange = (_event, newValue) => {
        setSelectedTab(newValue);
    };

    const getTopDepartments = (response) => {
        if (!response || !Array.isArray(response)) return [];
        return [...response]
            .sort((a, b) => b.count - a.count)
            .slice(0, 10);
    };

    useEffect(() => {
        const selectedResponse = selectedTab === 0 ? responseFemdepart : responseBemdepart;
        setTopDepartments(getTopDepartments(selectedResponse));
    }, [selectedTab, responseFemdepart, responseBemdepart]);

    const chartData = topDepartments.map((item) => ({
        department: item.departmentcode && item.departmentcode.trim() !== "" ? item.departmentcode : "Unknown",
        requestCount: item.count || 0,
    }));

    const noData = chartData.length === 0;

    useEffect(() => {
        if (chartRef.current) {
            const tspanElement = chartRef.current.querySelector(".MuiChartsAxis-label tspan");
            if (tspanElement) {
                tspanElement.setAttribute("dy", "-60px");
            }
        }
    }, [chartData]);

    return (
        <StyledCard>
            <CardContent>
                <Typography mb={1.5} variant="h5" fontWeight={700} color="text.primary">
                    Top 10 Department Requests
                </Typography>

                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    aria-label="Top 10 Department Requests"
                >
                    <Tab label="FEMS" />
                    <Tab label="BEMS" />
                </Tabs>

                <Box width="100%" height={300} ref={chartRef}>
                    {noData ? (
                        <Typography textAlign="center" color="text.secondary">
                            No Data Available
                        </Typography>
                    ) : (
                        <BarChart
                            dataset={chartData}
                            xAxis={[
                                {
                                    scaleType: "band",
                                    label: "Department Code",
                                    labelStyle: {
                                        textAnchor: "middle", // Horizontal alignment
                                        transform: "translateY(70px)",
                                    },
                                    dataKey: "department",
                                    tickLabelStyle: {
                                        textAnchor: "middle",
                                        dominantBaseline: "hanging",
                                        fontSize: 12,
                                    },
                                    valueFormatter: (value, context) => {
                                        if (context?.location === 'tooltip') {
                                            return value;
                                        }
                                        return value.length > 5 ? value.slice(0,4) + "…" : value;
                                    },
                                },
                            ]}
                            yAxis={[
                                {
                                    label: "Request Count",
                                },
                            ]}
                            series={[
                                {
                                    dataKey: "requestCount", label: "Request"
                                },
                            ]}
                            onItemClick={(event, item) => navigate("/departmentworkrequest")}
                            layout="vertical"
                            margin={{ bottom: 70, left: 60, right: 20, }}
                            slotProps={{
                                legend: { hidden: true },
                            }}
                        />
                    )}
                </Box>
            </CardContent>
        </StyledCard>
    );
};

export default TopDepartmentRequest;
